import { render, staticRenderFns } from "./allStoreList.vue?vue&type=template&id=06bc377c&scoped=true"
import script from "./allStoreList.vue?vue&type=script&lang=js"
export * from "./allStoreList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc377c",
  null
  
)

export default component.exports